const inputFieldMaxLength = {
    address: 200,
}

export default inputFieldMaxLength;
